import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { NotificationsComponent } from '../notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2'
import {Base} from '../base/base';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditVehicleComponent} from '../edit-vehicle/edit-vehicle.component';
import {EditDocumentUserComponent} from '../edit-document-user/edit-document-user.component';
import {EditDocumentVehicleComponent} from '../edit-document-vehicle/edit-document-vehicle.component';
import {EditDocumentLicenseComponent} from '../edit-document-license/edit-document-license.component';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent extends Base {
  isReject: boolean = false;
  descriptionReject: any = '';
  loading: boolean = false;
  message_description: any = '';
  dataReject: Array<Object>;
  public url_base = this.URL_BASE;
  @Input() public data;
  @Input() public action;
  @Input() public extra;

  constructor(injector: Injector,
              private form: FormBuilder,
              private router: Router,
              private NgxSpinner: NgxSpinnerService,
              private apis: ApisService,
              private modalService: NgbModal,
              private notification: NotificationsComponent) {
      super(injector);
  }

  ngOnInit() {
    console.log('llego data :: ', this.data, this.action, this.extra);
    switch (this.action) {
      case 'rejected':
        if (this.data) {
          this.apis.searchRejects(this.data).then(result => {
            if (result['status'] == 'success') {
              this.dataReject = result['data'];
              console.log(1234, this.dataReject);
            }
          });
        }
        break;
      case 'reject_documents_user':
        if (this.data) {
          this.apis.searchRejects(this.data).then(result => {
            if (result['status'] == 'success') {
              this.dataReject = result['data'];
              console.log(1234, this.dataReject);
            }
          });
        }
        break;
    }
  }

  editInformation(action, data) {
    let component;
    if (action == 'documents_user') {
      component = EditDocumentUserComponent;
    } else if (action == 'request_change_vehicle') {
      component = EditDocumentVehicleComponent;
    } else if (action == 'request_change_license') {
      component = EditDocumentLicenseComponent;
    } else {
      component = EditVehicleComponent;
    }

    const modalRef = this.modalService.open(component, {
      size: 'xl'
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.action = action;
  }

  clickButton(action) {
    console.log(action, ' ACTION');
    if (action == 'view_support') {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de envíar esta respuesta?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, envíar'
      }).then((result) => {
        console.log(' PASOOO 1111');
        if (result && result.value && result.value === true) {
          console.log(this.GetUser()[0].id, ' PASOOO 222222');
          this.loading = true;
          this.NgxSpinner.show('Guardando información');
          this.data['admin_id'] = this.GetUser()[0].id;
          this.data['admin_role_id'] = this.GetUser()[0].role_id;
          this.data['description_admin'] = this.message_description;
          console.log(this.data, ' PASOOO 333333');
          this.apis.AnswerTicket(this.data).then(response => {
            if (response['status'] == 'success' && response['data']) {
              this.NgSpinner.hide();
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                this.loading = false;
                this.modalService.dismissAll('success_save')
              }, 1200);
            }
          });
        }
      });
    } else if (action == 'accept') {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de que quieres aceptar los documentos?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
            this.NgxSpinner.show('Guardando información');
          this.loading = true;
          this.data['MessageReject'] = '';
            this.data['type'] = this.action;
            this.data['admin_id'] = this.GetUser()[0].id;
          console.log('LLEGO ACEP', this.data);
            this.apis.acceptDocumentsVehicle(this.data, action).then(response => {
              if (response['status'] == 'success' && response['data']) {
                this.NgSpinner.hide();
                this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
                setTimeout(() => {
                  this.modalService.dismissAll('success_save')
                }, 1200);
              }
            });
        }
      })
    } else if (action == 'request_change_vehicle' || action == 'request_change_license' || action == 'accept_change_vehicle') {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de que quieres aceptar los cambios?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.NgxSpinner.show('Guardando información');
          this.data['MessageReject'] = '';
          this.data['type'] = this.action;
          this.data['admin_id'] = this.GetUser()[0].id;
          this.data['isAccepted'] = true;
          this.loading = true;
          this.apis.RequestChangeInformation(this.data, action).then(response => {
            if (response['status'] == 'success' && response['data']) {
              this.NgSpinner.hide();
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                this.modalService.dismissAll('success_save')
              }, 1200);
            }
          });
        }
      })
    } else if (action == 'close') {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de cerrar el ticket?",
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, cerrar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.loading = true;
          this.NgxSpinner.show('Guardando información');
          this.data['admin_id'] = this.GetUser()[0].id;
          this.data['description_admin'] = this.message_description;
          this.apis.ChangeStateTicket(this.data, 'cancel').then(response => {
            if (response['status'] == 'success' && response['data']) {
              this.NgSpinner.hide();
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                this.loading = false;
                this.modalService.dismissAll('success_save')
              }, 1200);
            }
          });
        }
      });
    } else {
      this.isReject = true;
      if (this.descriptionReject) {
        this.NgxSpinner.show('Guardando información');
        this.data['MessageReject'] = this.descriptionReject;
        this.data['type'] = this.action;
        this.data['admin_id'] = this.GetUser()[0].id;
        this.data['isAccepted'] = false;
        this.loading = true;
        if (localStorage.getItem('typeVehicle') != null && localStorage.getItem('typeVehicle') == "motorcycle") {
          this.data['type'] = 'document_reject_motorcycle';
        }

        this.apis.RejectDocumentsVehicle(this.data, action).then(result => {
          if (result['status'] == 'success') {
            this.NgSpinner.hide();
            this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
            setTimeout(() => {
              location.reload();
            }, 1500);
          } else {
            this.NgSpinner.hide();
            this.notification.showNotification('bottom', 'left', 'error', 'Debes agregar una descripción de rechazo.');
          }
        });
      } else {
        this.notification.showNotification('bottom', 'left', 'error', 'Debes agregar una descripción de rechazo.');
      }
    }
  }

  clickButtonDocuments(action) {
    if (action == 'accept') {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de que quieres aceptar los documentos?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.NgxSpinner.show('Guardando información');
          this.loading = true;
          this.data['MessageReject'] = '';
          this.data['type'] = this.action;
          this.data['admin_id'] = this.GetUser()[0].id;
          this.apis.acceptDocumentsUser(this.data, action).then(result => {
            if (result['status'] == 'success' && result['data']) {
              this.NgSpinner.hide();
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                this.modalService.dismissAll('success_save')
              }, 1000);
            }
          });
        }
      })
    } else {
      this.isReject = true;
      if (this.descriptionReject) {
        this.NgxSpinner.show('Guardando información');
        this.data['MessageReject'] = this.descriptionReject;
        this.data['type'] = this.action;
        this.loading = true;
        this.data['admin_id'] = this.GetUser()[0].id;
        this.apis.RejectDocumentsDriver(this.data, action).then(result => {
          if (result['status'] == 'success') {
            this.NgSpinner.hide();
            this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
            setTimeout(() => {
              this.modalService.dismissAll('success_save')
            }, 1500);
          }
        });
      } else {
        this.NgSpinner.hide();
        this.notification.showNotification('bottom', 'left', 'error', 'Debes agregar una descripción de rechazo.');
      }
    }
  }
}
